export default "__VITE_ASSET__C7mBm5De__"